import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown } from "lucide-react";
import client, { fmtUsd, fmtPct } from "../lib/api";

const TickerItem = ({ c }) => {
  const up = (c.price_change_percentage_24h ?? 0) >= 0;
  return (
    <Link
      to={`/asset/crypto/${c.id}`}
      data-testid={`ticker-${c.id}`}
      className="inline-flex items-center gap-2 px-4 py-2 mx-1.5 rounded-xl hover:bg-white/5 transition-colors whitespace-nowrap group"
    >
      <img src={c.image} alt={c.name} className="w-5 h-5 rounded-full" />
      <span className="text-[11px] uppercase tracking-wider text-neutral-400 font-mono-num">{c.symbol}</span>
      <span className="font-mono-num text-sm">{fmtUsd(c.current_price)}</span>
      <span className={`inline-flex items-center gap-0.5 font-mono-num text-xs ${up ? "up" : "down"}`}>
        {up ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
        {fmtPct(c.price_change_percentage_24h)}
      </span>
    </Link>
  );
};

const CryptoTicker = () => {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    let cancelled = false;
    let retries = 0;
    const load = () => {
      client.get("/crypto/markets?per_page=20")
        .then(({ data }) => {
          if (!cancelled && (data.results || []).length) {
            setCoins(data.results);
          }
        })
        .catch(() => {
          // Retry quickly a few times on initial failure (e.g., cold cache 502)
          if (retries < 3 && !cancelled) {
            retries++;
            setTimeout(load, 2000);
          }
        });
    };
    load();
    const id = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (coins.length === 0) {
    // Show a thin placeholder bar so the layout doesn't jump
    return (
      <div
        data-testid="crypto-ticker-loading"
        className="relative h-10 border-y border-white/[0.06] bg-white/[0.015] backdrop-blur flex items-center justify-center"
      >
        <span className="text-[11px] uppercase tracking-widest text-neutral-500">Loading live prices…</span>
      </div>
    );
  }

  // Duplicate the list once so the marquee loops seamlessly
  const tickerCoins = [...coins, ...coins];

  return (
    <div
      data-testid="crypto-ticker"
      className="relative overflow-hidden border-y border-white/[0.06] bg-white/[0.015] backdrop-blur"
      style={{ maskImage: "linear-gradient(to right, transparent, black 6%, black 94%, transparent)" }}
    >
      <div className="ticker-track py-2.5">
        {tickerCoins.map((c, i) => <TickerItem key={`${c.id}-${i}`} c={c} />)}
      </div>
    </div>
  );
};

export default CryptoTicker;
